import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { InputField, SelectField } from '@/shared/components/atoms';
import FileInput from '@/shared/components/atoms/FileInput';

import Upload from '~/images/shared/Upload.svg';

interface Props {
  supplierCrops: IReconciliation.IGetWorkdaySupplierCrops[];
  edit?: boolean;
  suffix: string | null | undefined;
}

const ModalForm: React.FC<Props> = ({ edit, supplierCrops, suffix }) => {
  const { t } = useTranslation('common');
  // eslint-disable-next-line no-console

  const {
    register,
    reset,
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  return (
    <div className='flex flex-col gap-24'>
      {edit && getValues('expenseType') === 'Supervision' && (
        <>
          <SelectField
            id='deductionType'
            isDisabled={true}
            borderColor='#f2f2f2'
            label={t('adding-method')}
            getLabel={(item: { label: string; value: string }) =>
              t(item.label.toLowerCase())
            }
            getValue={(item: { label: string; value: string }) => item.value}
            required
            className='border-background-disable'
            list={[
              {
                label: t('percentage-as-unit'),
                value: 1,
              },
              {
                label: t('val'),
                value: 0,
              },
            ]}
            width='w-full'
            placeholder={t('adding-method')}
          />
          <SelectField
            id='expenseType'
            isDisabled={true}
            borderColor='#f2f2f2'
            label={t('type')}
            getLabel={(item: { label: string; value: string }) =>
              t(item.label.toLowerCase())
            }
            getValue={(item: { label: string; value: string }) => item.value}
            required
            className='border-background-disable'
            list={[
              {
                label: t('supervision'),
                value: 'Supervision',
              },
              {
                label: t('administrative'),
                value: 'Administrative',
              },
            ]}
            width='w-full'
            placeholder={t('type')}
          />
        </>
      )}
      {edit && getValues('expenseType') === 'Supervision' ? (
        <InputField
          placeholder={t('applied-to')}
          label={t('applied-to')}
          {...register('memberName')}
          error={Boolean(errors?.memberName)}
          errorMessage={errors?.memberName?.message || ''}
          className='min-w-[50%]'
          customDisabledStyle='bg-background-disable pointer-events-none opacity-5'
          disabled
          borderColor='border-background-disable'
          textColor='text-text-600'
          width='w-full'
        />
      ) : (
        <></>
      )}
      <SelectField<IReconciliation.IGetWorkdaySupplierCrops, false>
        id='cropId'
        label={t('crop-upon-agreement')}
        getLabel={(item: { cropName: string }) => t(item.cropName)}
        getValue={(item: { cropId: number }) => item.cropId}
        required
        isDisabled={edit}
        className='border-background-disable'
        list={supplierCrops}
        borderColor='#f2f2f2'
        width='w-full'
        placeholder={`${t('choose')} ${t('crop-type')}`}
      />
      {edit && getValues('expenseType') === 'Supervision' && (
        <InputField
          placeholder={t('the-job-order')}
          label={t('the-job-order')}
          {...register('jobInstanceId')}
          error={Boolean(errors?.jobInstanceId)}
          errorMessage={errors?.jobInstanceId?.message || ''}
          className='min-w-[50%]'
          customDisabledStyle='bg-background-disable pointer-events-none opacity-5'
          disabled
          borderColor='border-background-disable'
          textColor='text-text-600'
          width='w-full'
        />
      )}
      <InputField
        id='amount'
        // defaultValue={data?.amount}
        label={t('amount')}
        placeholder={t('enter-amount')}
        {...register('amount')}
        required
        error={Boolean(errors?.amount)}
        errorMessage={errors?.amount?.message || ''}
        className='min-w-[50%]'
        borderColor='border-background-disable'
        textColor='text-text-600'
        width='w-full'
        suffix={<span>{suffix}</span>}
      />
      <Controller
        name='attachment'
        control={control}
        // eslint-disable-next-line unused-imports/no-unused-vars
        render={({ field: { onChange, value, ...rest } }) => (
          <FileInput
            accept='image/png, image/gif, image/jpeg'
            {...rest}
            onChange={(e) => {
              if (e.target.files) {
                onChange({ target: { value: e.target.files[0] } });
              }
            }}
            placeholder={`${t('upload')} ${t('attachments')}`}
            aria-invalid={errors.attachment ? 'true' : 'false'}
            label={t('attachments')}
            error={Boolean(errors?.attachment)}
            errorMessage={errors?.attachment?.message || ''}
            className='min-w-[50%]'
            borderColor='border-background-disable'
            textColor='text-text-600'
            width='w-full'
            suffix={<Upload />}
          />
        )}
      />
      <InputField
        placeholder={`${t('add')} ${t('note')}`}
        label={t('note')}
        {...register('note')}
        error={Boolean(errors?.note)}
        errorMessage={errors?.note?.message || ''}
        className='min-w-[50%]'
        borderColor='border-background-disable'
        textColor='text-text-600'
        multiline
        width='w-full'
      />
    </div>
  );
};
export default ModalForm;
